module.exports = __webpack_public_path__ + "img/warningIcon.b7d731ec.png";